import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HeaderNav } from "@/components/HeaderNav";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const u = await login(email.trim(), password);
      toast.success("Welcome back");
      if (u.role === "super_admin") navigate("/admin");
      else if (u.role === "org_admin") navigate("/org");
      else navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div>
      <HeaderNav />
      <div className="max-w-md mx-auto px-5 pt-24 pb-16 cg-fade-up">
        <h1 className="font-serif text-4xl text-[#F3F4F6] mb-2">Welcome back</h1>
        <p className="text-[#9CA3AF] mb-8">Return to your Authority Portrait.</p>
        <form onSubmit={submit} className="cg-card p-7 space-y-5">
          <div>
            <label className="text-sm text-[#9CA3AF]">Email</label>
            <input data-testid="login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full bg-[#0D0E12] border border-[var(--cg-border)] rounded-lg px-4 py-3 text-[#F3F4F6] focus:border-brass focus:outline-none transition-colors" />
          </div>
          <div>
            <label className="text-sm text-[#9CA3AF]">Password</label>
            <input data-testid="login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full bg-[#0D0E12] border border-[var(--cg-border)] rounded-lg px-4 py-3 text-[#F3F4F6] focus:border-brass focus:outline-none transition-colors" />
          </div>
          <div className="-mt-2 text-right">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-sm cg-link">Forgot password?</Link>
          </div>
          {error && <p data-testid="login-error" className="text-sm text-terracotta">{error}</p>}
          <button data-testid="login-submit-button" disabled={busy}
            className="w-full bg-brass text-obsidian font-medium py-3 rounded-full cg-scale-btn hover:bg-amber2 disabled:opacity-60">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="mt-5 text-sm text-[#9CA3AF]">
          Don't have an account? <Link to="/register" data-testid="to-register-link" className="cg-link">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
